var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTesTiQLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TESTiQ_logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 315.058,
    height: 57.677,
    viewBox: "0 0 315.058 57.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1335",
    "data-name": "Rectangle 1335",
    width: 315.058,
    height: 57.677,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M0,53.111H51.022V2.089H0ZM6.756,25.09c8.06-.33,7.793-8.206,11.9-13.7a12.013,12.013,0,0,1,6.923-4.616,25.154,25.154,0,0,1,4.836-.623v5.458a7.824,7.824,0,0,0-4.836.77c-3.626,1.832-4.725,6.521-6.923,10.66-2.052,3.883-4.9,7.323-11.9,7.47Zm6.9,14.65V34.358a7.8,7.8,0,0,0,5-1.758c3.26-2.674,3.956-7.949,6.923-11.979A12.148,12.148,0,0,1,32.5,16.042a22.637,22.637,0,0,1,4.836-.586v5.4a7.814,7.814,0,0,0-4.836.79c-3.626,1.832-4.726,6.521-6.924,10.661-1.465,2.747-3.406,5.311-6.923,6.594a16.17,16.17,0,0,1-5,.839M32.5,41.575c-1.466,2.747-3.407,5.275-6.924,6.594a15.169,15.169,0,0,1-4.983.879V43.626a7.758,7.758,0,0,0,4.983-1.758c3.26-2.638,3.956-7.913,6.924-11.942,2.162-2.858,5.458-5.056,11.759-5.2l.006,5.432c-8.133-.842-8.8,5.815-11.766,11.42",
    transform: "translate(0 -0.242)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M117.03,1.4V11H101.465V53.329H90.046V11H74.481V1.4Z",
    transform: "translate(-8.602 -0.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M168.167,1.4V11h-27.42V22.127h25.165V31H140.748V43.728h28v9.6H129.328V1.4Z",
    transform: "translate(-14.937 -0.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M220.878,16.729H209.823c-.364-5.236-3.419-7.854-10.182-7.854-4.218,0-7.928,1.818-7.928,5.891,0,3.782,2.182,4.509,13.819,7.418,7.71,1.964,17.093,4.583,17.093,15.565,0,9.818-7.783,16.655-21.6,16.655-10.982,0-22.11-5.236-22.11-18.11V35.93h11.055c0,7.346,6.036,9.6,11.418,9.6,5.237,0,10.183-1.745,10.183-6.473,0-3.274-2.546-5.31-8.947-6.91-3.855-1.019-7.2-1.746-10.546-2.837-7.855-2.618-11.419-7.055-11.419-13.674C180.657,5.165,190.549,0,200.076,0c11.128,0,20.8,4.946,20.8,16.729",
    transform: "translate(-20.664 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M271.95,1.4V11H256.385V53.329H244.966V11H229.4V1.4Z",
    transform: "translate(-26.495 -0.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M290.43,8.962h-6.182V1.4h6.182Zm0,44.367h-6.182v-37.6h6.182Z",
    transform: "translate(-32.83 -0.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M349.7,27.2c0,7.71-2.473,15.347-7.855,20.657l6.837,5.455-3.492,4.364-7.927-6.4A23.582,23.582,0,0,1,324.827,54.4c-15.492,0-24.874-12-24.874-27.2,0-7.854,2.255-14.328,6.764-19.492S317.263,0,324.827,0C340.756,0,349.7,12.146,349.7,27.2M324.827,48.585a18.44,18.44,0,0,0,7.2-1.455l-5.746-4.582,3.636-4.218,6.91,5.527c3.855-3.855,5.964-9.818,5.964-16.656,0-6.109-1.6-11.273-4.728-15.273q-4.8-6.11-13.31-6.11c-5.6,0-9.965,2.037-13.165,6.11-3.128,4.072-4.728,9.163-4.728,15.273,0,12.584,7.056,21.384,17.965,21.384",
    transform: "translate(-34.644 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesTiQLogo);
export default __webpack_public_path__ + "static/media/TESTiQ_logo.5fe6eaf5e5d958bffeff3af9587432d4.svg";
export { ForwardRef as ReactComponent };